<template>
  <div>
    <div style="display: flex; justify-content: end; align-items: center; margin-top: -0.5rem">
      <div class="md-layout-item md-size-40" style="padding-left: 0">
        <md-field>
          <label for="currentType">Type</label>
          <md-select v-model="currentType" name="currentType">
            <md-option v-for="(type, index) in userTypes" :key="index" :value="type.value">
              {{ type.label }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </div>

    <div style="margin-top: -2rem">
      <div v-if="currentType === 'technicians'">
        <mgmt-techniciansV2 @openChangePasswordModal="handleChangePasswordModal"
          @openOrgEditModal="handleOrgEditModal"></mgmt-techniciansV2>
      </div>
      <div v-if="currentType === 'readers'">
        <mgmt-readers @openChangePasswordModal="handleChangePasswordModal"
          @openOrgEditModal="handleOrgEditModal"></mgmt-readers>
      </div>
      <div v-if="currentType === 'admins'">
        <mgmt-admins @openChangePasswordModal="handleChangePasswordModal"
          @openOrgEditModal="handleOrgEditModal"></mgmt-admins>
      </div>
      <div v-if="currentType === 'doctors'">
        <mgmt-doctors @openChangePasswordModal="handleChangePasswordModal"
          @openOrgEditModal="handleOrgEditModal"></mgmt-doctors>
      </div>
      <div v-if="currentType === 'patients'">
        <mgmt-patients @openChangePasswordModal="handleChangePasswordModal"
          @openOrgEditModal="handleOrgEditModal"></mgmt-patients>
      </div>

      <div v-if="isSelectOrgModalOpen">
        <select-multi-org-modal :is-open="isSelectOrgModalOpen" :selected-user="selectedUser" :user-type="currentType"
          @close="closeOrgEditModal"></select-multi-org-modal>
      </div>

      <md-dialog v-if="changePasswordUser" :md-active.sync="isChangePasswordModalOpen"
        :md-click-outside-to-close="false">
        <md-dialog-title>Change Password</md-dialog-title>

        <md-dialog-content>
          <div>
            <div>Change password for <b>{{ changePasswordUser.name }}</b>
            </div>
          </div>
        </md-dialog-content>
        <div style="padding: 0 24px;">
          <md-field slot="inputs" :class="[
            { 'md-valid': !errors.has('psw1') && touched.psw1 },
            { 'md-form-group': true },
            { 'md-error': errors.has('psw1') && touched.psw1 }
          ]">
            <md-icon>lock_outline</md-icon>
            <label>New Password</label>
            <md-input v-model="psw1" name="password" type="password" v-validate="psw1Validation" ref="password"
              data-vv-name="psw1" />
          </md-field>
        </div>
        <div style="padding: 0 24px;">
          <md-field slot="inputs" :class="[
            { 'md-valid': !errors.has('psw2') && touched.psw2 },
            { 'md-form-group': true },
            { 'md-error': errors.has('psw2') && touched.psw2 }
          ]">
            <md-icon>lock_outline</md-icon>
            <label>Re-enter Password</label>
            <md-input v-model="psw2" name="password_confirmation" type="password"
              v-validate="'required|confirmed:password'" data-vv-as="password" data-vv-name="psw2" />

          </md-field>
          <div style="font-size: 12px;color: red;margin-top: -5px;margin-left: 2.3rem;"
            v-if="errors.has('psw2') && touched.psw2 && psw2">Passwords don't match</div>
        </div>

        <md-dialog-actions style="justify-content: center;margin-bottom: 1rem;">
          <md-button :disabled="isChangingPassword"
            @click="isChangePasswordModalOpen = false; changePasswordUser = null"
            style="width: 130px;background-color: white !important;box-shadow: none;color: #000 !important;">
            Cancel
          </md-button>
          <md-button class="md-primary" :disabled="isChangingPassword" @click="handleHhangePasswordAction()"
            style="width: 130px;">
            <span :class="[{ 'changing-password': isChangingPassword }]">
              {{ isChangingPassword ? 'Changing...' : 'Change' }}
            </span>
          </md-button>
        </md-dialog-actions>
      </md-dialog>

    </div>
  </div>
</template>

<script>
import mgmtTechniciansV2 from "@/pages/Portal/Views/Admin/Pages/mgmtTechniciansV2.vue"
import mgmtDoctors from "@/pages/Portal/Views/Admin/Pages/mgmtDoctors.vue"
import mgmtReaders from "@/pages/Portal/Views/Admin/Pages/mgmtReaders.vue"
import mgmtPatients from "@/pages/Portal/Views/Admin/Pages/mgmtPatients.vue"
import mgmtAdmins from "@/pages/Portal/Views/Admin/Pages/mgmtAdmins.vue"
import selectMultiOrgModal from "@/components/modals/selectMultiOrgModal.vue"
import { SlideYDownTransition } from "vue2-transitions"
import Swal from "sweetalert2"

export default {
  name: "ManageUsers",
  components: {
    mgmtTechniciansV2,
    mgmtDoctors,
    mgmtReaders,
    mgmtPatients,
    mgmtAdmins,
    selectMultiOrgModal,
    SlideYDownTransition
  },
  data() {
    return {
      currentType: "doctors",
      isSuperAdmin: false,
      selectedUser: null,
      changePasswordUser: null,
      isSelectOrgModalOpen: false,
      isChangePasswordModalOpen: false,
      psw: null,
      psw1: null,
      psw2: null,
      status: null,
      touched: {
        psw1: false,
        psw2: false,
      },
      psw1Validation: {
        required: true,
        min: 5
      },
      isChangingPassword: false,
    }
  },
  computed: {
    userTypes() {
      return [
        { label: "Technicians", value: "technicians" },
        { label: "Doctors", value: "doctors" },
        { label: "Readers", value: "readers" },
        { label: "Patients", value: "patients" },
        { label: "Admins", value: "admins" }
      ]
    }
  },
  created: function () { },
  mounted: function () { },
  updated: function () { },
  destroyed: function () { },
  methods: {
    handleOrgEditModal(user) {
      this.selectedUser = user
      this.isSelectOrgModalOpen = true
    },
    handleChangePasswordModal(user) {
      this.changePasswordUser = user;
      this.isChangePasswordModalOpen = true;
      this.psw1 = null;
      this.psw2 = null;
      this.touched = {
        psw1: false,
        psw2: false,
      };
    },
    closeOrgEditModal() {
      this.isSelectOrgModalOpen = false
      this.selectedUser = null
    },
    async handleHhangePasswordAction() {
      this.touched.psw1 = true;
      this.touched.psw2 = true;
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return;
      }
      this.psw = null
      if (this.psw1 && this.psw2 && this.psw1.trim() != this.psw2.trim()) {
        return;
      } else {
        this.psw = this.psw1
      }
      this.isChangingPassword = true;
      const url = `${process.env.VUE_APP_URL}/user/${this.changePasswordUser.personId}/password`
      const data = {
        password: this.psw
      }
      const config = { headers: { "Content-Type": "application/json" } }
      try {
        await window.axios.patch(url, data, config);
        Swal.fire({
          title: "Success",
          text: "The password was changed successfully",
          icon: "success",
          confirmButtonText: "OK"
        })
        this.isChangePasswordModalOpen = false;
        this.changePasswordUser = null;
      } catch (e) {
        console.log(e);
        Swal.fire({
          title: "Error",
          text: "We couldn't change the user password now. Try again later",
          type: "error",
          confirmButtonClass: "md-button md-info",
          buttonsStyling: false,
          timer: 3000
        })
      } finally {
        this.isChangingPassword = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.changing-password {
  clip-path: inset(0 1ch 0 0);
  animation: l 1s steps(4, jump-none) infinite;
}

@keyframes l {
  to {
    clip-path: inset(0)
  }
}
</style>
